
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Schlafwandel – oder eben Somnambulismus – gilt als eine Schlafstörung. Betroffen sind vor allem Kinder. Bis zu 30 Prozent haben in ihrer Kindheit einmal ein Schlafwandel-Erlebnis. Aber weder schlafwandelnde Kinder noch Erwachsene können sich an diese Episoden erinnern, da sie in den tiefsten Phasen des traumfreien Non-REM-Schlafes passieren. Die Ursache des des Somnambulismus ist nicht abschliessend geklärt, doch die Wissenschaft deutet Untersuchungen dahin, dass ein unerwarteter Anstieg der Aktivität im Nervensystem während des Tiefschlafes ein Auslöser sein könnten.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;